import React from 'react'
import { cn } from '../lib/utils'

export interface PageHeaderProps {
  title: React.ReactNode
  subtitle?: React.ReactNode
  actions?: React.ReactNode
  className?: string
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, actions, className }) => {
  return (
    <div className={cn('flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between', className)}>
      <div className="space-y-1 min-w-0">
        <h1 className="text-3xl sm:text-4xl font-bold text-foreground truncate">{title}</h1>
        {subtitle ? (
          <p className="text-base text-foreground/60">{subtitle}</p>
        ) : null}
      </div>
      {actions ? (
        <div className="flex items-center gap-3 self-start">{actions}</div>
      ) : null}
    </div>
  )
}

export default PageHeader
